import React, { CSSProperties, useState } from "react";
import { Image } from "react-bootstrap";

interface InputFieldProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  containerStyle?: CSSProperties | undefined;
  isError?: boolean;
  error?: string;
  containerClass?:string
}
function InputField({
  type,
  error,
  label,
  isError,
  containerClass,
  containerStyle,
  className,
  ...props
}: InputFieldProps) {
  const [show, setShow] = useState(false);
  const inputType = type === "password" && !show ? "password" : "text";
  return (
    <div className={`mb-3 ${containerClass}`} style={containerStyle}>
      {!!label && (
        <label className="form-label fw-semibold mb-2">{label}</label>
      )}
      <div className="form-control d-flex align-items-center px-2">
        <input
          {...props}
          type={inputType}
          className={`border-0 flex-grow-1 ${className}`}
          style={{ outline: "none", boxShadow: "none" ,...props.style}}
        />
        {type == "password" && (
          <Image
            src={!show ? "/images/eye-password-show.svg" : "/images/eye-password-hide.svg"}
            onClick={() => setShow((prev) => !prev)} 
            style={{height:20}}
          />
        )}
      </div>
      {!!isError && <div className="input-error-message">{error}</div>}
    </div>
  );
}

export default InputField;
